import { render, staticRenderFns } from "./ExpertList.vue?vue&type=template&id=d479fc66&scoped=true"
import script from "./ExpertList.vue?vue&type=script&lang=js"
export * from "./ExpertList.vue?vue&type=script&lang=js"
import style0 from "./ExpertList.vue?vue&type=style&index=0&id=d479fc66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d479fc66",
  null
  
)

export default component.exports